module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6501f7ed297cb10ddd19fbb59e6dc9b9.png";